import api from '@/client/core/api'

export type InstagramInstantwinPrizeOption = {
  id: number
  name: string
}

export type GetInstagramInstantwinPrizesParams = {
  campaignId: number
  forCsv?: number
}

export type InstagramInstantwinPrizesApiResponse = {
  data?: {
    prizes: InstagramInstantwinPrizeOption[]
  }
  error?: {
    type?: string
    message?: string
    status?: number
  }
}

export class InstagramInstantwinPrizesApiError extends Error {
  constructor(
    public type: string,
    message?: string,
    public status?: number
  ) {
    super(message || type)
  }
}

export async function getInstagramInstantwinPrizes(
  params: GetInstagramInstantwinPrizesParams
): Promise<InstagramInstantwinPrizeOption[]> {
  const response = await api.get<InstagramInstantwinPrizesApiResponse>('/instagram_instantwin_prizes', { params })

  if (response?.error?.type) {
    throw new InstagramInstantwinPrizesApiError(response.error.type, response.error.message, response.error.status)
  }

  return response.data?.prizes ?? []
}
